.heading {
  color: var(--palette-content-neutral-strong);
  margin-bottom: var(--sizes-spacing-4);
}
